const selectedListContainer = document.querySelector('.filter__selectedlist')
const categories = document.querySelectorAll('.productlisttable__category')
const filterSelected = document.querySelector('.filter__selected')
const cardParents = document.querySelectorAll('.card__parent')
const selectedList = []
const searchParams = new URLSearchParams(window.location.search)
const urlFilters = decodeURIComponent(searchParams.get('filters'))
const itemOutput = document.querySelector('.productstype')
const filterMessge = document.querySelector('.filtermessage')
let items = null
let isProductView = null
let arrowsSet = false

const Filter = {
  init(target) {
    const filterContainers = target.querySelectorAll('.filter__container')
    const filterSelectors = target.querySelector('.filter__selectorscontainer')
    const inputs = target.querySelectorAll('input')
    const viewType = target.getAttribute('data-viewType')

    isProductView = viewType && viewType === 'list'

    filterContainers.forEach((el) => {
      el.addEventListener('click', (e) => this.doOpen(e, filterContainers))
      el.addEventListener('keydown', (e) => this.doOpen(e, filterContainers))
    })
    this.resize(filterContainers)
    window.addEventListener('resize', () => this.resize(filterContainers))
    document.addEventListener('click', (e) => this.isClickInside(e, filterSelectors, filterContainers))
    inputs.forEach((input) => {
      input.addEventListener('change', (e) => this.onChange(e, inputs))

      if (urlFilters.includes(input.value)) {
        input.checked = true

        if ('createEvent' in document) {
          const evt = document.createEvent('HTMLEvents')
          evt.initEvent('change', false, true)
          input.dispatchEvent(evt)
        }
      }
    })

    items = isProductView
      ? document.querySelectorAll('.productlisttable__product')
      : itemOutput.querySelectorAll('.card')

    this.updateDisplay()
  },
  resize(filterContainers) {
    const windowW = window.innerWidth
    if (windowW > 992) {
      filterContainers.forEach((el) => {
        const filterArrow = el.querySelector('.filter__arrow')

        if (filterArrow) {
          const selectLocation = el.offsetLeft
          filterArrow.style.left = `${selectLocation + 30}px`
        }
      })
      arrowsSet = true
    } else if (arrowsSet) {
      filterContainers.forEach((el) => {
        const filterArrow = el.querySelector('.filter__arrow')

        if (filterArrow) {
          filterArrow.style.left = null
        }
      })
    }
  },
  removeItem(k, inputs) {
    inputs.forEach((input) => {
      if (input.value === k) {
        input.checked = false
      }
    })

    const indexb = selectedList.indexOf(k)
    if (indexb > -1) {
      selectedList.splice(indexb, 1)
    }

    this.updateUrlParams()
    this.updateSelectedOutput(inputs)
  },
  onChange(e, inputs) {
    const { currentTarget } = e
    if (currentTarget.checked) {
      selectedList.push(currentTarget.value)
    } else {
      this.removeItem(currentTarget.id, inputs)
      const index = selectedList.indexOf(currentTarget.value)
      if (index > -1) {
        selectedList.splice(index, 1)
      }
    }

    this.updateUrlParams()
    this.updateSelectedOutput(inputs)
  },
  comparator(a, b) {
    return a.dataset.availableproducts.localeCompare(b.dataset.availableproducts, undefined, { numeric: true })
  },
  updateDisplay() {
    if (items && items.length > 0) {
      items.forEach((el) => {
        let displayEl = 0
        const itemFilterTypes = el.getAttribute('data-filter')
        if (!itemFilterTypes) {
          return
        }

        const itemFilterTypesArr = itemFilterTypes.split(',')

        if (itemFilterTypesArr.length > 0) {
          itemFilterTypesArr.forEach((itemType) => {
            if (selectedList.includes(itemType.trim())) {
              displayEl++
            }
          })
        }

        const toggleElement = isProductView ? el : el.parentElement

        if (displayEl === selectedList.length) {
          toggleElement.classList.remove('hide')
        } else {
          toggleElement.classList.add('hide')
        }
      })

      if (selectedList.length <= 0) {
        Array.from(categories).forEach((cat) => {
          cat.classList.remove('hide')
        })
      }

      if (selectedList.length > 0) {
        if (isProductView) {
          this.sort()
        } else {
          this.sortItems()
        }
      } else {
        Array.from(categories).forEach((cat) => {
          const catHasAvailable = parseInt(cat.getAttribute('data-availableproducts'), 10)

          if (catHasAvailable < 1) {
            cat.classList.add('hide')
          }

          cat.removeAttribute('style')
        })

        Array.from(cardParents).forEach((par) => {
          par.removeAttribute('style')
        })
      }
    }
  },
  toggleMessageDisplay(hide) {
    if (hide) {
      filterMessge.classList.add('hide')
    } else {
      filterMessge.classList.remove('hide')
    }
  },
  sort() {
    const categoriesArr = Array.from(categories)
    categoriesArr.forEach((cat) => {
      const childItems = cat.querySelectorAll('.productlisttable__product:not(.hide)')
      if (childItems.length > 0) {
        cat.classList.remove('hide')
      } else {
        cat.classList.add('hide')
      }

      cat.setAttribute('data-availableproducts', childItems.length.toString())
    })

    const availableCategories = !!categoriesArr.filter((cat) => !cat.classList.contains('hide')).length
    this.toggleMessageDisplay(availableCategories)

    const sorted = categoriesArr.sort(this.comparator).reverse()

    sorted.forEach((el, i) => {
      el.setAttribute('style', `order:${i};`)
    })
  },
  sortItems() {
    const cardParentsArr = Array.from(cardParents)

    cardParentsArr.forEach((parent) => {
      const childItem = parent.querySelector('.card:not(.hide)')
      const availableItems = childItem.getAttribute('data-availableproducts')
      parent.setAttribute('data-availableproducts', availableItems)
    })

    const availableCategories = !!cardParentsArr.filter((par) => !par.classList.contains('hide')).length
    this.toggleMessageDisplay(availableCategories)

    const sorted = cardParentsArr.sort(this.comparator).reverse()

    sorted.forEach((el, i) => {
      el.setAttribute('style', `order:${i};`)
    })
  },
  updateUrlParams() {
    searchParams.set('filters', encodeURIComponent(selectedList.toString()))
    let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`

    if (selectedList.length) {
      newUrl = `${newUrl}?${searchParams.toString()}`
    }

    if (document.getElementsByClassName('productfilter--catalog')[0]) {
      newUrl = newUrl.replace('vorur', 'vorulisti')
      newUrl = newUrl.replace('products', 'catalog')
      window.location.href = newUrl
    } else {
      window.history.pushState({ path: newUrl }, '', newUrl)
    }
  },
  updateSelectedOutput(inputs) {
    selectedListContainer.innerHTML = ''

    if (selectedList.length) {
      selectedList.forEach((selectedItem) => {
        const li = document.createElement('li')
        li.classList.add('filter__selecteditem')
        const newButton = document.createElement('button')
        newButton.innerHTML = `<span class="filter__selectedtext">${selectedItem}</span> <span class="filter__selecteditemclose"></span>`
        newButton.addEventListener('click', () => this.removeItem(selectedItem, inputs))
        li.appendChild(newButton)
        selectedListContainer.appendChild(li)
      })
      filterSelected.classList.add('filter__selected--active')
    } else {
      filterSelected.classList.remove('filter__selected--active')
    }

    this.updateDisplay()
  },
  closeAll(filterContainers) {
    filterContainers.forEach((f) => {
      const selectorContainer = f.querySelector('.filter__selectorscontainer')

      if (selectorContainer) {
        selectorContainer.setAttribute('aria-expanded', 'false')
      }
      f.classList.remove('filter--open')
    })
  },
  isClickInside(e, filterSelectors, filterContainers) {
    const isClickInside = filterSelectors && filterSelectors.contains(e.target)

    if (!isClickInside) {
      this.closeAll(filterContainers)
    }
  },
  doOpen(e, filterContainers) {
    const isAlreadyOpen = e.currentTarget.classList.contains('filter--open')
    e.stopPropagation()
    this.closeAll(filterContainers)

    if (!isAlreadyOpen) {
      const selectorContainer = e.currentTarget.querySelector('.filter__selectorscontainer')
      if (selectorContainer) {
        selectorContainer.setAttribute('aria-expanded', 'true')
      }
      e.currentTarget.classList.add('filter--open')
    }
  },
}

export default Filter
